export default __webpack_public_path__ + "static/imagePC-86b11799eb145516ea7d78545cbfa84e.svg";